import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";

export default function Profile() {
  const { user, setUser } = useAuth();
  const nav = useNavigate();

  const deleteAccount = async () => {
    try { await api.delete("/account"); setUser(false); toast.success("Votre compte a été supprimé."); nav("/"); }
    catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div>
      <h2 className="font-heading text-2xl text-ink mb-5">Mon profil</h2>
      <div className="bg-cream border border-line rounded-lg p-6 space-y-4 max-w-lg">
        <div><Label>Nom</Label><Input value={user?.name || ""} disabled className="bg-sand border-line mt-1" data-testid="profile-name" /></div>
        <div><Label>E-mail</Label><Input value={user?.email || ""} disabled className="bg-sand border-line mt-1" data-testid="profile-email" /></div>
        <div><Label>Méthode de connexion</Label><Input value={user?.provider === "google" ? "Google" : "E-mail / mot de passe"} disabled className="bg-sand border-line mt-1" /></div>
      </div>

      <div className="bg-cream border border-destructive/30 rounded-lg p-6 mt-6 max-w-lg">
        <h3 className="font-heading text-lg text-ink">Suppression du compte (RGPD)</h3>
        <p className="text-sm text-ink-muted mt-1">Vous pouvez demander la suppression de votre compte et de vos données personnelles. Cette action est irréversible.</p>
        <AlertDialog>
          <AlertDialogTrigger asChild><Button variant="destructive" className="mt-4" data-testid="delete-account">Supprimer mon compte</Button></AlertDialogTrigger>
          <AlertDialogContent className="bg-sand">
            <AlertDialogHeader><AlertDialogTitle className="font-heading">Supprimer votre compte ?</AlertDialogTitle>
              <AlertDialogDescription>Toutes vos données personnelles seront supprimées. Vous perdrez l'accès à vos eBooks. Cette action est définitive.</AlertDialogDescription></AlertDialogHeader>
            <AlertDialogFooter><AlertDialogCancel>Annuler</AlertDialogCancel><AlertDialogAction onClick={deleteAccount} className="bg-destructive text-white" data-testid="confirm-delete-account">Supprimer définitivement</AlertDialogAction></AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </div>
    </div>
  );
}
